let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iVQNH")).then(() => parcelRequire('5Uxlx'));